export default __webpack_public_path__ + "static/media/grid3.3932e46d.png";